export default from './RecipeDetails';


/** WEBPACK FOOTER **
 ** ./app/components/recipeDetails/index.js
 **/